"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

var CustomTooltip = function CustomTooltip(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
    title: props.title,
    placement: props.placement,
    disableFocusListener: props.disabled,
    disableHoverListener: props.disabled,
    disableTouchListener: props.disabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: props.children
    })
  });
};

CustomTooltip.defaultProps = {
  title: '',
  disabled: false
};
CustomTooltip.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  disabled: _propTypes.default.bool,
  placement: _propTypes.default.string
};
var _default = CustomTooltip;
exports.default = _default;
//# sourceMappingURL=CustomTooltip.js.map